export default "__VITE_ASSET__Bxif0krg__"